export const s = {
  name: 'Emlak Turu',
  pitch: 'Şehir al, otel dik, rakibi kirayla batır. Şans kartında istersen gerçek görev yap.',
  settings: {
    readOnly: 'Ayarları oda sahibi seçer.',
    mode: 'Nasıl oynanacak',
    solo: 'Herkes tek',
    teams: 'Takımlı',
    teamCount: 'Takım sayısı',
    teamHint: 'Bir oyuncuya dokununca takımı değişir. Takımlar eşit olmak zorunda değil; seçilmeyenler başlarken dağıtılır.',
    team: (n: number) => `Takım ${n}`,
    unassigned: 'Takımı yok',
    empty: 'Henüz kimse yok',
    shuffle: 'Karıştır',
    minutes: 'Oyun süresi',
    minutesValue: (n: number) => `${n} dk`,
    minutesHint: 'Süre dolunca en zengin kazanır. Son 5 dakikada kiralar 2 kat.',
    turnSeconds: 'Hamle süresi',
    secondsValue: (n: number) => `${n} sn`,
    realTasks: 'Gerçek hayat görevleri',
    realTasksHint: 'Açıksa şans kartı çıkınca oyuncu kartı uygulamak yerine görevi seçebilir. Yapamazsa kart uygulanır.',
    on: 'Açık',
    off: 'Kapalı',
    categories: 'Görev paketleri',
    categoriesHint: 'Şans kartlarında yalnızca seçtiğin paketlerden görev çıkar.',
    adultHint: '+18 paket seçtin: görevler yetişkinler içindir, oyuncular istemedikleri görevi kartı uygulayarak atlayabilir.',
    addTask: 'Kendi görevini yaz',
    addPlaceholder: 'Örn: Masanın altından geç',
    addButton: 'Ekle',
    added: (t: string) => `Eklendi: ${t}. Arkadaş görevleri paketinde.`,
    addFailed: 'Görev eklenemedi. Tekrar dene.',
  },
  play: {
    pickTitle: 'Karakterini seç',
    pickHint: 'Figüre ya da adına dokun. Süre dolunca kalanlara otomatik atanır.',
    taken: 'Alındı',
    spectator: 'Bu oyunu izliyorsun.',
    clock: 'Kalan',
    final: 'Son dakikalar: kiralar 2 kat',
    jailed: 'Hapiste',
    shield: 'Kalkan',
    out: 'İflas',
    team: (nicks: string) => nicks,
    yourTurn: 'Sıra sende',
    turnOf: (name: string) => `Sıra ${name} oyuncusunda`,
    actor: (nick: string) => `Hamleyi ${nick} yapıyor`,
    roll: 'Zar at',
    rollHint: 'Çift gelirse bir daha atarsın',
    jailHint: (bail: string) => `Hapistesin. Çift at ya da ${bail} kefalet öde.`,
    bail: (bail: string) => `Kefalet öde (${bail})`,
    moving: 'Zar atılıyor',
    buy: (price: string) => `${price} karşılığında satın al?`,
    buyInfo: (rent: string, hotel: string) => `Kira ${rent}, otelde ${hotel}`,
    buyButton: 'Satın al',
    upgrade: 'Şehri yükselt?',
    hotelUp: 'Otel dik?',
    upgradeInfo: (cost: string, rent: string) => `${cost} öde, kira ${rent} olsun`,
    upgradeButton: 'Yükselt',
    takeover: (price: string) => `${price} karşılığında devral?`,
    takeoverInfo: (name: string) => `Para ${name} oyuncusuna gider. Şehir ve binaları senin olur.`,
    takeoverButton: 'Devral',
    noMoney: 'Paran yetmiyor',
    skip: 'Geç',
    waitDecide: (name: string) => `${name} karar veriyor`,
    tour: 'Tur: istediğin kareye uç',
    tourInfo: (fee: string) => `Tahtadan bir kareye dokun. Ücret ${fee}.`,
    chance: 'Şans kartı',
    realTask: 'Gerçek görev',
    doTask: 'Görevi yap',
    applyCard: 'Kartı uygula',
    taskRunning: 'Görev sürüyor',
    taskWatch: (name: string) => `${name} görevi yapıyor. İzle, sonra oyla.`,
    taskEveryone: 'Herkes seni izliyor',
    taskDone: 'Bitirdim, oylamaya geç',
    taskQuit: 'Vazgeç, kartı uygula',
    voteTitle: (name: string, task: string) => `${name} "${task}" görevini yaptı mı?`,
    voteHint: 'Eşitlikte görev başarılı sayılır.',
    voted: 'Oyun alındı',
    voteDone: 'Yaptı',
    voteFailed: 'Yapamadı',
    voteWaiting: (name: string) => `Rakipler ${name} için oyluyor`,
    voteCount: (d: number, f: number, p: number) => `Yaptı ${d} · Yapamadı ${f} · Bekleyen ${p}`,
    debt: (amount: string) => `${amount} borcun var`,
    debtInfo: (need: string) => `${need} daha lazım. Şehir sat ya da iflas et.`,
    debtWait: (name: string) => `${name} borcunu kapatmaya çalışıyor`,
    sell: (name: string, value: string) => `${name} sat (+${value})`,
    bankrupt: 'İflas et',
    cityOwner: (name: string) => `Sahibi: ${name}`,
    cityFree: 'Sahibi yok',
    cityRent: (rent: string) => `Kira ${rent}`,
    cityPrice: (price: string) => `Fiyat ${price}`,
    levels: ['', '1 ev', '2 ev', '3 ev', 'Otel'],
    close: 'Kapat',
    feed: 'Olanlar',
  },
  podium: {
    gameOver: 'Oyun bitti',
    winner: (n: string) => `${n} kazandı!`,
    tie: (n: string) => `${n} berabere`,
    reason: { time: 'Süre doldu, en zengin kazandı.', last: 'Ayakta kalan son oyuncu.', groups: 'Üç renk grubunu topladı.', host: 'Oda sahibi oyunu bitirdi.' },
    worth: 'Servet',
    cities: (n: number) => `${n} şehir`,
    out: 'İflas etti',
    back: 'Lobiye dönülüyor',
  },
};
